import { render, staticRenderFns } from "./Form.vue?vue&type=template&id=67313157&"
import script from "./form.js?vue&type=script&lang=js&"
export * from "./form.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports